"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
const react_1 = require("react");
const themes_1 = require("../themes");
function useTheme() {
    const { theme } = react_1.useContext(themes_1.ThemeContext);
    return theme;
}
exports.useTheme = useTheme;
//# sourceMappingURL=useTheme.js.map